import { AppStore, AppStoreDefault } from '../app/store';
import { LeadStore, LeadStoreDefault } from '../lead/store';

/**
 * Stores state shape interface
 *
 * @export
 * @interface State
 */
export interface State {
	app: AppStore;
	lead: LeadStore;
}

/**
 * Stores state shape property map
 *
 * @export
 * @param {State} state
 */
export const mapStateToProps = (state: State) => {
	return {
		app: state.app,
		lead: state.lead
	};
};

/**
 * Default (initial) state of all stores
 *
 * @export
 * @constant
 */
export const initialState: State = {
	app: AppStoreDefault,
	lead: LeadStoreDefault
};
